<template>
  <div class="ideas-block__subsection">
    <div
      class="ideas-block__subsection-header"
      :class="{'is-active': isShow}"
      @click.prevent="showSubsection"
    >
      <div class="ideas-block__subsection-title">
        {{ title }}
      </div>
      <div class="ideas-block__section-icon" />
    </div>

    <div
      v-if="isShow"
      class="ideas-block__subsection-files"
    >
      <a
        v-for="(file,index) in files"
        :key="index"
        :class="['ideas-block__subsection-file', {'ideas-block__subsection-file_color': file.isMastercardAutor}]"
        :href="file.fileUrl ? `${setUrl()}${file.fileUrl}` :file.externalUrl"
        :target="file.type == 'pdf' || file.externalUrl ? '_blank' : '_self'"
        download=""
      >
        <div v-if="file.type === 'youtube'" class="ideas-block__subsection-file-type"><Youtube /></div>
        <div v-else-if="file.type === 'link'" class="ideas-block__subsection-file-type"><Link /></div>
        <div v-else class="ideas-block__subsection-file-type">.{{ file.type }}</div>
        <span>{{ fileNameCut(file.title) }}</span>
        <!-- <span>{{ file.title > 20 ? file.title.slice(0, 17) +'...' : file.title }}</span> -->
      </a>

      <!-- <button v-if="files.length > 10" class="ideas-block__subsection-show-more" @click.prevent="closeAccordion">
        Згорнути акордеон
      </button> -->
    </div>
  </div>
</template>

<script>
  import Youtube from '@/assets/svg/youtube.svg'
  import Link from '@/assets/svg/link.svg'
  export default {
    name: 'Subsections',

    components: {
      Youtube,
      Link
    },

    props: {
      title: {
        type: String,
        default: ''
      },
      files: {
        type: Array,
        default: () => []
      }
    },

    data () {
      return {
        isShow: false,
        showFiles: []
      }
    },

    computed: {
    },

    created () {

    },

    methods: {
      showSubsection () {
        this.isShow = !this.isShow
      },
      closeAccordion () {
        this.isShow = !this.isShow
        if (this.$store.getters.isMobile) {
          window.scrollTo(0, 600)
        }
      },
      setUrl () {
        return process.env.VUE_APP_API
      },
      fileNameCut (title) {
        return title.length > 90 ? `${title.slice(0, 86)} ...` : title
      }
    }
  }
</script>


<style lang="scss">
.ideas-block__subsection {
  padding: 24px 0 22px;
  width: 100%;
  max-width: 1014px;
  margin-left: auto;
  border-top: 2px solid #DBDBDB;

    @include tablet {
      max-width: 665px;
    }

    @include mobile {
      padding: 16px 0;
      max-width: calc(100% - 50px);
    }

  &:last-child {
    border-bottom: 2px solid #DBDBDB;
  }

  &-wrapp {
    margin-top: 34px;

    @include mobile {
      margin-top: 16px;
    }
  }

  &-header {
    position: relative;
    cursor: pointer;
    box-sizing: border-box;

    @include hover {
      .ideas-block__subsection-title {
        color: rgba($c-black,0.7);
      }
    }

      &.is-active {
        .ideas-block__section-icon::after {
          transform: rotate(180deg);
        }
      }
  }

  &-title {
    font-size: 24px;
    line-height: 1.34;
    color: rgba($c-black,0.4);
    transition: 0.3s;

    @include mobile {
      font-size: 18px;
      color: rgba($c-black,1);
    }
  }

  &-files {
    margin-top: 45px;
    display: flex;
    flex-wrap: wrap;
    columns: 2;

    @include mobile {
      columns: 1;
    }
  }

  &-file {
    width: 50%;
    display: flex;
    align-items: flex-start;
    text-decoration: none;
    margin-bottom: 30px;
    transition: 0.3s;

    @include mobile {
      width: 100%;
    }

    @include hover {
      opacity: 0.5;
    }

    &-type {
      min-width: 32px;
      max-width: 32px;
      height: 32px;
      background: url('/file.png');
      display: flex;
      justify-content: center;
      align-items: flex-end;
      font-size: 8px;
      line-height: 16px;
      color: $c-black;

      @include mobile {
        width: 100%;
      }
    }

    svg {
      margin-bottom: 3px;
    }

    span {
      margin-left: 11px;
      font-size: 16px;
      font-weight: 500;
      line-height: 18px;
      color: $c-medium-black;
      width: 100%;
      max-width: 325px;
      margin-top: 5px;

      @include tablet {
        max-width: 250px;
      }

      @include mobile {
        font-size: 12px;
        line-height: 14px;
      }
    }

    &_color {
      .ideas-block__subsection-file-type {
        background: url('/file-color.png');
      }

      svg > * {
        fill: $c-red;
      }

      span {
        color: $c-red;
      }
    }
  }

  &-show-more {
    background-color: transparent;
    padding: 5px;
    border-radius: 4px;
    cursor: pointer;
  }
}
</style>
